module.exports = __webpack_public_path__ + "static/media/gameTerraform.e0339971.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/gameTerraform.png
// module id = 2247
// module chunks = 0